/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class RestoreRdsSubnetGroupsRdsSubnetGroupsInner {
  /**
  * Then name of the subnet group
  */
  'name': string;
  /**
  * The vpc id of the subnet group
  */
  'vpc': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "vpc",
      "baseName": "vpc",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreRdsSubnetGroupsRdsSubnetGroupsInner.attributeTypeMap;
  }

  public constructor() {
  }
}

